import { RouteConfig } from "vue-router";

const locales: RouteConfig = {
  path: "/locales",
  name: "locales",
  component: () => import(/* webpackChunkName: "locales" */ "@/views/Locales.vue"),
};

export default locales;
